import { type Program } from './programsData';

export const apparelProgramsData: Program = {
  id: "apparel",
  category: "Apparel",
  focusArea: "Fashion design, tailoring, garment production",
  description: "Master the art of fashion and garment creation. Our apparel programs cover fashion design, tailoring, garment production, and merchandising. Students learn cutting-edge techniques and traditional craftsmanship to excel in the fashion industry.",
  color: "#00184dff",
  image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  levels: [
    {
      id: "apparel-cert-12th",
      level: "Certificate",
      eligibility: "12th",
      courses: [
        { id: "cutting-supervisor-cert-12th", name: "Cutting Supervisor", duration: "6", durationUnit: "Month", eligibility: "12th" },
        { id: "self-employed-tailor-cert-12th", name: "Self Employed Tailor", duration: "6", durationUnit: "Month", eligibility: "12th" },
        { id: "assistant-fashion-designer-cert-12th", name: "Assistant Fashion Designer", duration: "6", durationUnit: "Month", eligibility: "12th" },
        { id: "hand-embroiderer-cert-12th", name: "Hand Embroiderer", duration: "6", durationUnit: "Month", eligibility: "12th" },
        { id: "merchandiser-cert-12th", name: "Merchandiser", duration: "6", durationUnit: "Month", eligibility: "12th" },
        { id: "fashion-designing-cert-12th", name: "Fashion Designing", duration: "6", durationUnit: "Month", eligibility: "12th" },
        { id: "sewing-machine-operator-cert-12th", name: "Sewing Machine Operator", duration: "6", durationUnit: "Month", eligibility: "12th" },
        { id: "trade-fashion-designing-cert-12th", name: "Trade Fashion Designing", duration: "6", durationUnit: "Month", eligibility: "12th" },
        { id: "cutting-sewing-cert-12th", name: "Cutting & Sewing", duration: "6", durationUnit: "Month", eligibility: "12th" }
      ]
    },
    {
      id: "apparel-cert-10th",
      level: "Certificate",
      eligibility: "10th",
      courses: [
        { id: "cutting-supervisor-cert-10th", name: "Cutting Supervisor", duration: "6", durationUnit: "Month", eligibility: "10th" },
        { id: "self-employed-tailor-cert-10th", name: "Self Employed Tailor", duration: "6", durationUnit: "Month", eligibility: "10th" },
        { id: "assistant-fashion-designer-cert-10th", name: "Assistant Fashion Designer", duration: "6", durationUnit: "Month", eligibility: "10th" },
        { id: "hand-embroiderer-cert-10th", name: "Hand Embroiderer", duration: "6", durationUnit: "Month", eligibility: "10th" },
        { id: "merchandiser-cert-10th", name: "Merchandiser", duration: "6", durationUnit: "Month", eligibility: "10th" },
        { id: "fashion-designing-cert-10th", name: "Fashion Designing", duration: "6", durationUnit: "Month", eligibility: "10th" },
        { id: "sewing-machine-operator-cert-10th", name: "Sewing Machine Operator", duration: "6", durationUnit: "Month", eligibility: "10th" },
        { id: "trade-fashion-designing-cert-10th", name: "Trade Fashion Designing", duration: "6", durationUnit: "Month", eligibility: "10th" },
        { id: "cutting-sewing-cert-10th", name: "Cutting & Sewing", duration: "6", durationUnit: "Month", eligibility: "10th" }
      ]
    },
    {
      id: "apparel-diploma-12th",
      level: "Diploma",
      eligibility: "12th",
      courses: [
        { id: "cutting-supervisor-diploma-12th", name: "Cutting Supervisor", duration: "1", durationUnit: "Year", eligibility: "12th" },
        { id: "self-employed-tailor-diploma-12th", name: "Self Employed Tailor", duration: "1", durationUnit: "Year", eligibility: "12th" },
        { id: "assistant-fashion-designer-diploma-12th", name: "Assistant Fashion Designer", duration: "1", durationUnit: "Year", eligibility: "12th" },
        { id: "hand-embroiderer-diploma-12th", name: "Hand Embroiderer", duration: "1", durationUnit: "Year", eligibility: "12th" },
        { id: "merchandiser-diploma-12th", name: "Merchandiser", duration: "1", durationUnit: "Year", eligibility: "12th" },
        { id: "fashion-designing-diploma-12th", name: "Fashion Designing", duration: "1", durationUnit: "Year", eligibility: "12th" },
        { id: "sewing-machine-operator-diploma-12th", name: "Sewing Machine Operator", duration: "1", durationUnit: "Year", eligibility: "12th" },
        { id: "trade-fashion-designing-diploma-12th", name: "Trade Fashion Designing", duration: "1", durationUnit: "Year", eligibility: "12th" },
        { id: "cutting-sewing-diploma-12th", name: "Cutting & Sewing", duration: "1", durationUnit: "Year", eligibility: "12th" }
      ]
    },
    {
      id: "apparel-diploma-10th",
      level: "Diploma",
      eligibility: "10th",
      courses: [
        { id: "cutting-supervisor-diploma-10th", name: "Cutting Supervisor", duration: "1", durationUnit: "Year", eligibility: "10th" },
        { id: "self-employed-tailor-diploma-10th", name: "Self Employed Tailor", duration: "1", durationUnit: "Year", eligibility: "10th" },
        { id: "assistant-fashion-designer-diploma-10th", name: "Assistant Fashion Designer", duration: "1", durationUnit: "Year", eligibility: "10th" },
        { id: "hand-embroiderer-diploma-10th", name: "Hand Embroiderer", duration: "1", durationUnit: "Year", eligibility: "10th" },
        { id: "merchandiser-diploma-10th", name: "Merchandiser", duration: "1", durationUnit: "Year", eligibility: "10th" },
        { id: "fashion-designing-diploma-10th", name: "Fashion Designing", duration: "1", durationUnit: "Year", eligibility: "10th" },
        { id: "sewing-machine-operator-diploma-10th", name: "Sewing Machine Operator", duration: "1", durationUnit: "Year", eligibility: "10th" },
        { id: "trade-fashion-designing-diploma-10th", name: "Trade Fashion Designing", duration: "1", durationUnit: "Year", eligibility: "10th" },
        { id: "cutting-sewing-diploma-10th", name: "Cutting & Sewing", duration: "1", durationUnit: "Year", eligibility: "10th" }
      ]
    }
  ]
};
